const COMMON_URL = `${process.env.REACT_APP_COMMON_SERVICE_ORIGIN_URL}/account-setup`

const AccessLevelRuleApiUrls = {
  GET: `${COMMON_URL}/access-level-rule/hdr/get`,
  POST: `${COMMON_URL}/access-level-rule/hdr/create`,
  PUT: `${COMMON_URL}/access-level-rule/hdr/update`,
  DELETE: `${COMMON_URL}/access-level-rule/hdr/delete`,
  EXPORT: `${COMMON_URL}/access-level-rule/hdr/download`
}

export default AccessLevelRuleApiUrls
